import React from 'react';
import ReactDOM from 'react-dom';
import NotificationList from '../components/notification/NotificationList';
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderNotificationList = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<NotificationList props={props} />, element);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering NotificationList:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};